export default __webpack_public_path__ + "static/signature-81d35cd242c4982fe88c03acb963e1a3.png";